export default __webpack_public_path__ + "static/media/payment4.7a7f40df.webp";